import { token } from '@atlaskit/tokens';
import { styled } from '@compiled/react';

export const OuterContainer = styled.div({
  paddingTop: token('space.400'),
  paddingBottom: token('space.800'),
  minHeight: 'calc(100vh - 150px)',
  backgroundColor: token('color.background.neutral'),
});

export const InnerContainer = styled.div({
  maxWidth: '70%',
  margin: '0 auto',
  padding: `0 ${token('space.300')}`,
});
